import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';

export const landingpageConfigurationGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  if (landingpageConfigurationStateService.hasConfiguration()) {
    return true;
  }

  try {
    await landingpageConfigurationStateService.fetchConfiguration();
    return true;
  } catch {
    sessionStorage.clear();
    return router.parseUrl('/');
  }
};
